import { titleClasses } from "./title.styles";

export type TitleInterProps = {
  title: string;
  variant?: "h1" | "h2" | "h3";
};

const Title = ({ title, variant = "h1" }: TitleInterProps) => {
  const classes = titleClasses(variant);
  return (
    <div className={classes.container}>
      {variant === "h1" && <h1 className={classes.title}>{title}</h1>}
      {variant === "h2" && <h2 className={classes.title}>{title}</h2>}
      {variant === "h3" && <h3 className={classes.title}>{title}</h3>}
    </div>
  );
};

export default Title;
